<template>
        <div class="success-style">
            <img  src="./../../assets/images/success.png"/>
            <span class="success-text">提交成功</span>
        </div>
    
</template>
<script>

export default ({
    data(){
        return{}
    },
    mounted(){
        (function flexible(window,document){
            var docEl = document.documentElement
            var dpr = window.devicePixelRatio || 1
            function setBodyFontSize(){
                if(document.body){
                    document.body.style.fontSize = 12 * dpr + 'pr'
                }else {
                    document.addEventListener('DOMContentLoaded',setBodyFontSize)
                }
            }
            setBodyFontSize()
            function setRemUnit(){
                var rem = docEl.clientWidth / 10
                docEl.style.fontSize = rem + 'px'
            }
            setRemUnit()
            window.addEventListener('resize',setRemUnit)
            window.addEventListener('pageshow',function(e){
                setRemUnit()
            })
            if (dpr >= 2) {
              var fakeBody = document.createElement('body')
              var testElement = document.createElement('div')
              testElement.style.border = '.5px solid transparent'
              fakeBody.appendChild(testElement)
              docEl.appendChild(fakeBody)
              if (testElement.offsetHeight === 1) {
                docEl.classList.add('hairlines')
              }
              docEl.removeChild(fakeBody)
            }
          })(window, document)
        }
        
        
    
})
</script>
<style lang="scss" scoped>
.success-style{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
        img{
            width:20rem;
            height: 20rem;
        }
    .success-text{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 5rem;
        font-size: 2.5rem;

    }
}
</style>



// WEBPACK FOOTER //
// src/view/sharePage/success.vue